// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerPackageCompositionResponse

import { hydratePackageCompositionDetail, type PackageCompositionDetail, type PackageCompositionDetailApiResponse } from './packageCompositionDetail.gen';
import { hydrateCustomerPackageUsage, type CustomerPackageUsage, type CustomerPackageUsageApiResponse } from './customerPackageUsage.gen';

export type CustomerPackageCompositionApiResponse = {
	id: number;
	initialQuantity: number;
	quantity: number;
	details: PackageCompositionDetailApiResponse[];
	usages: CustomerPackageUsageApiResponse[];
};

export type CustomerPackageComposition = {
	id: number;
	initialQuantity: number;
	quantity: number;
	details: PackageCompositionDetail[];
	usages: CustomerPackageUsage[];
};

export function hydrateCustomerPackageComposition(data: CustomerPackageCompositionApiResponse): CustomerPackageComposition {
	return {
		...data,
		details: data.details.map(hydratePackageCompositionDetail),
		usages: data.usages.map(hydrateCustomerPackageUsage),
	};
}